import { wkblScriptInit } from 'redux/reducers/init';
import {
  changeWkblScriptAsc,
  changeWkblScriptPage,
  changeWkblScriptReturnCount,
  changeWkblScriptSort,
  clearWkblScriptList,
  requestWkblScriptList,
  requestWkblScriptListFailure,
  requestWkblScriptListSuccess,
} from 'redux/actions/actions';

import { createReducer } from '@reduxjs/toolkit';

const wkblScript = createReducer(wkblScriptInit, {
  [requestWkblScriptList.type]: (state, action) => {
    state.isLoading = true;
  },
  [requestWkblScriptListSuccess.type]: (state, action) => {
    const { wkblScriptList, pagination, returnCount } = action.payload;
    pagination.returnCount = returnCount;
    state.isLoading = false;
    state.wkblScriptList = wkblScriptList;
    state.pagination = pagination;
  },
  [requestWkblScriptListFailure.type]: (state, action) => {
    state.isLoading = false;
    state.wkblScriptList = [];
    state.pagination = {
      pageNumber: 0,
      pageCount: 0,
      itemCount: 0,
    };
  },
  [changeWkblScriptPage.type]: (state, action) => {
    const { pageNumber } = action.payload;
    state.searchCondition.page = pageNumber;
  },
  [changeWkblScriptSort.type]: (state, action) => {
    const { sort } = action.payload;
    state.searchCondition.sort = sort;
  },
  [changeWkblScriptAsc.type]: (state, action) => {
    const { asc } = action.payload;
    state.searchCondition.asc = asc;
  },
  [changeWkblScriptReturnCount.type]: (state, action) => {
    const { returnCount } = action.payload;
    state.searchCondition.retr = returnCount;
    state.searchCondition.page = 0; // ReturnCount 변경시 1페이지부터 다시 조회
  },
  [clearWkblScriptList.type]: (state, action) => {
    state.wkblScriptList = [];
  },
});

export default wkblScript;
